

















import Vue from 'vue';
import MobileMenuEntry from './MobileMenuEntry.vue';

export default Vue.extend({
  name: `MobileMenuParents`,
  components: {
    MobileMenuEntry,
  },
  props: {
    submenu: {
      default: null,
      validator: prop => typeof prop === `object` || prop === null,
    },
    topic: {
      default: null,
      validator: prop => typeof prop === `object` || prop === null,
    },
  },
});
